import XLSX_ICON from '@gp/assets/svg/upload-file/xlsx.svg';
import CSV_ICON from '@gp/assets/svg/upload-file/csv.svg';
import DOC_ICON from '@gp/assets/svg/upload-file/doc.svg';
import PPT_ICON from '@gp/assets/svg/upload-file/ppt.svg';
import PDF_ICON from '@gp/assets/svg/upload-file/pdf.svg';
import COMMON_IMG_ICON from '@gp/assets/svg/upload-file/common-img.svg';
import PNG_IMG_ICON from '@gp/assets/svg/upload-file/png-img.svg';
import VIDEO_ICON from '@gp/assets/svg/upload-file/video.svg';

import type { IRecord } from '@gp/types/global';

export const FILE_ICONS: IRecord<string> = {
  xls: XLSX_ICON,
  xlsx: XLSX_ICON,
  csv: CSV_ICON,
  doc: DOC_ICON,
  docx: DOC_ICON,
  ppt: PPT_ICON,
  pptx: PPT_ICON,
  pdf: PDF_ICON,
  jpg: COMMON_IMG_ICON,
  jpeg: COMMON_IMG_ICON,
  png: PNG_IMG_ICON,
  bmp: COMMON_IMG_ICON,
  webp: COMMON_IMG_ICON,
  mp4: VIDEO_ICON,
  avi: VIDEO_ICON,
  wmv: VIDEO_ICON,
  mpeg: VIDEO_ICON,
  m4v: VIDEO_ICON,
  mov: VIDEO_ICON,
  asf: VIDEO_ICON,
  flv: VIDEO_ICON,
  f4v: VIDEO_ICON,
  rmvb: VIDEO_ICON,
  rm: VIDEO_ICON,
  mkv: VIDEO_ICON,
};
